import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CatEditFormComponent } from './cat-edit-form/cat-edit-form.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { TemplateEditComponent } from './template-edit/template-edit.component';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';

const routes: Routes = [
  {
    path: '', pathMatch: 'full', redirectTo: 'form'
  },
  {
    path: 'form',
    component: CatEditFormComponent
  },
  {
    path: 'productdetails',
    component: ProductDetailsComponent
  },
  {
    path: 'template-edit',
    component: TemplateEditComponent
  },
  {
    path: 'bulk-upload',
    component: BulkUploadComponent
  },
  {
    path: 'order-confirmation/:id',
    component: OrderConfirmationDetailsComponent
  },
  {
    path: 'order-confirmation/bulk/:id',
    component: OrderConfirmationDetailsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatEditRoutingModule { }
